<script setup>
import { defineModel } from 'vue';
import { useModal } from 'vue-final-modal';
import SignatureModal from '../SignatureModal.vue';

const signature = defineModel({ type: String });

const props = defineProps({
    placeholder: {
        type: String,
        required: true
    },
    error: {
        type: String,
        default: ''
    },
    inputClasses: {
        type: String,
        default: ''
    }
});

const { open, close } = useModal({
    component: SignatureModal,
    attrs: {
        signature,
        onClose($event) {
            signature.value = $event;
            close();
        }
    }
});
</script>

<template>
    <div class="tw-mb-4">
        <div class="tw-flex tw-items-center" @click="open">
            <input
                class="input-text tw-pr-4"
                :class="{ 'input-text--muted': signature, 'tw-border-red': error }"
                :placeholder="props.placeholder"
                :value="signature"
                type="text"
                readonly
            />
        </div>

        <p v-if="props.error" class="tw-text-sm tw-mb-4 tw-mt-2 tw-text-red tw-block">
            {{ props.error }}
        </p>
    </div>
</template>

<style scoped>
.input-text--muted {
    background-color: transparent;
    border-color: transparent;
    font-family: 'Yellowtail', cursive;
    font-size: 28px;
    padding-left: 0;
}
</style>
